import { Either } from "fp-ts/lib/Either";
import UserEntity from "../entities/UserEntity";
import ExceptionEntity from "../entities/ExceptionEntity";

export default interface AuthRepository {
    signIn: (email: string, password: string) => Promise<Either<ExceptionEntity, UserEntity>>;
    signInWithActiveDirectory: () => Promise<Either<ExceptionEntity, UserEntity>>;
    signUp: (email: string, password: string) => Promise<Either<ExceptionEntity, void>>;
    signOut: () => Promise<Either<ExceptionEntity, void>>;
    sendRecoveryCode: (email: string) => Promise<Either<ExceptionEntity, void>>
    sendConfirmCode: (email: string) => Promise<Either<ExceptionEntity, void>>
    confirmUser: (email: string, code: string) => Promise<Either<ExceptionEntity, void>>
    updatePassword: (oldPassword: string, newPassword: string, email: string) => Promise<Either<ExceptionEntity, void>>
    updatePasswordByRecovery: (email: string, newPassword: string, code: string) => Promise<Either<ExceptionEntity, void>>
    getCurrentUser: () => Promise<Either<ExceptionEntity, UserEntity>>
    addUser: (user: UserEntity, password: string) => Promise<Either<ExceptionEntity, void>>
    deleteUser: () => Promise<Either<ExceptionEntity, void>>
    refreshToken: () => Promise<Either<ExceptionEntity, void>>
}


export const AuthRepositoryName = 'AuthRepository';